module.exports = __webpack_public_path__ + "static/img/auth-bg-blue-png.22b7108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-bg-blue-png.png
// module id = E0JE
// module chunks = 0